import { useMutation } from "react-query";
import createUser from "../services/createUser";

const useCrateUserMutation = () => {
  return useMutation(["create-user"], createUser);
};

export default useCrateUserMutation;
